export type Exception = Error & {
	errors?: ApiError[];
	status?: number;
	url?: string;
	data?: any;
};

export interface ApiError {
	code?: string;
	field?: string;
	message: string;
	type?: string;
	value?: string;
	missing_permissions?: string[];
	eligible_users?: string[];
	arguments?: Record<string, any>;
	organization_name?: string;
}

export interface ItemResponse<T> {
	data: T;
}

export interface ListResponse<T> {
	data: Array<T>;
}

export interface MoneyApi {
	amount: number;
	currency: string;
}

export interface MoneyApiForm {
	amount: number | null | undefined;
	currency: string;
}

export interface ListDataRequestResponse<T = any, U = any> {
	data: Array<T>;
	nextPage?: boolean;
	summary?: U;
}

export interface SubscriptionEstimationApi {
	name: string;
	features: SubscriptionEstimationFeatureApi[];
	price_delta: MoneyApi;
	billing_period: BillingPeriod;
	trial_days: number;
	total_price: MoneyApi;
	required_plan?: string;
	required_addons: boolean;
	free_of_charge: boolean;
	actual_plan?: string;
}

export interface SubscriptionEstimationFeatureApi {
	id: string;
	description?: string;
}

export interface SubscriptionEstimationFeatureTranslation {
	id: string;
	name: string;
}

export enum BillingPeriod {
	MONTHLY = "MONTHLY",
	YEARLY = "YEARLY",
}
